export { default as load } from './cldr/load';
export { default as setData } from './cldr/set-data';
export { default as dateFieldName } from './cldr/date-field-name';
export { default as dateFormatNames } from './cldr/date-format-names';
export { cldr, localeInfo } from './cldr/info';
export { currencyDisplays, currencyDisplay, currencyFractionOptions, territoryCurrencyCode, localeCurrency } from './cldr/currency';
export { default as firstDay } from './cldr/first-day';
export { default as weekendRange } from './cldr/weekend-range';
export { default as numberSymbols } from './cldr/number-symbols';




//////////////////
// WEBPACK FOOTER
// ./~/@telerik/kendo-intl/dist/es/cldr.js
// module id = 61
// module chunks = 93